<template>
  <div class="part-inventory-batch-dialog">
    <custom-dialog width="1200px" :title="$t('dms_part_inventory_batch_dialog.dao_ru_ling_jian')" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <div class="btn-group">
          <div class="btn-add ub-f1">
            <input type="file" ref="file" id="file" multiple="multiple" @change="handleFile" />
            <div style="display: inline-block">
              <i class="icon icon-add"></i>
              <span>
                {{ $t('dms_part_inventory_batch_dialog.qxzxdrlj') }}
              </span>
            </div>
          </div>
          <div class="btn-tpl" @click="onDownloadTpl">
            <div style="display: inline-block">
              <i class="icon icon-daochu"></i>
              <span>{{ $t('dms_part_inventory_batch_dialog.xzljmb') }}</span>
            </div>
          </div>
        </div>
        <div class="tip-box">
          <div v-if="tip" class="result" v-html="tip"></div>
        </div>
        <div class="search" style="height: 40px; overflow: hidden">
          <el-form :inline="true">
            <el-form-item>
              <el-button @click="showOk = true" :type="showOk ? 'primary' : ''" :plain="!showOk">{{ $t('dms_part_inventory_batch_dialog.tong_guo_yan_zheng') }}（{{ okNum }}）</el-button>
            </el-form-item>
            <el-form-item>
              <el-button @click="showOk = false" :type="!showOk ? 'primary' : ''" :plain="showOk">{{ $t('dms_part_inventory_batch_dialog.yi_chang_shu_ju') }}（{{ failNum }}）</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!-- 验证通过 -->
        <div v-show="showOk">
          <custom-table :data="okList" :tableCode="tableCode" @filter="filterChange" @sort="sortChange" :filterArr="['errorMsg']"></custom-table>
          <div class="table-page">
            <el-pagination
              border
              v-if="okNum"
              @size-change="onSizeChange1"
              @current-change="onCurrentPage1"
              :current-page="failForm.pageNum"
              :page-sizes="pageSizeList"
              :page-size="failForm.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="okNum"
            ></el-pagination>
          </div>
        </div>
        <!-- 验证失败 -->
        <div v-show="!showOk">
          <custom-table :data="failList" :tableCode="tableCode" @filter="filterChange" @sort="sortChange"></custom-table>
          <div class="table-page">
            <el-pagination
              border
              v-if="failNum"
              @size-change="onSizeChange2"
              @current-change="onCurrentPage2"
              :current-page="failForm.pageNum"
              :page-sizes="pageSizeList"
              :page-size="failForm.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="failNum"
            ></el-pagination>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">
          {{ $t('Common.com_cancel') }}
        </el-button>
        <el-button v-if="showOk" type="primary" :disabled="!okForm.flag || !okNum" @click="saveBatchImport">
          {{ $t('dms_part_inventory_batch_dialog.que_ding_dao_ru') }}
        </el-button>
        <el-button v-else type="primary" :disabled="!okForm.flag || !failNum" @click="onDownloadFail">{{ $t('Common.com_export') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      // visible: false,
      tableCode: 'part_inventory_batch',

      okForm: {
        flag: '',
        type: 'ok',
        pageNum: 1,
        pageSize: 50,
      },
      failForm: {
        flag: '',
        type: 'fail',
        pageNum: 1,
        pageSize: 50,
      },
      failList: [],
      failNum: 0,
      okList: [],
      okNum: 0,
      showOk: true,
      tip: '',
    };
  },
  mounted() {
    this.resetOkForm = JSON.stringify(this.okForm);
    this.resetFailForm = JSON.stringify(this.failForm);
    this.init();
  },
  methods: {
    // 初始化
    init: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      this.okForm = JSON.parse(this.resetOkForm);
      this.failForm = JSON.parse(this.resetFailForm);
      this.failList = [];
      this.failNum = 0;
      this.okList = [];
      this.okNum = 0;
      this.showOk = true;
      this.tip = '';
      // this.getTableColumn();
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // 模板下载
    onDownloadTpl: function () {
      this.$exportFlie(apis.partStockDownloadTemplate);
    },
    // 文件上传
    handleFile: function (e) {
      this.$postFile(apis.partStockExcel, e).then((res) => {
        if (!res.data) {
          res.data = {};
        }
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$refs.file.value = '';
        this.failNum = res.data.failNum || 0;
        this.okNum = res.data.okNum || 0;
        this.okForm.flag = res.data.flag;
        this.failForm.flag = res.data.flag;
        const total = this.failNum + this.okNum;
        this.tip = this.$t('dms_part_inventory_batch_dialog.bcydrotqzsspantsbwtg', [total,this.okNum,this.failNum]);
        // 默认获取成功条数
        this.getBatchOk();
        // 失败条数
        this.getBatchFail();
      });
    },
    // 异常导出
    onDownloadFail: function () {
      this.$exportFlie(apis.partStockExportFailData, {
        flag: this.failForm.flag,
      });
    },

    // 获取检测列表分页
    getBatchOk: function () {
      this.$getJSON(apis.partStockCheckDataPage, this.okForm).then((res) => {
        this.okList = res.data.list;
      });
    },
    // 获取检测列表分页
    getBatchFail: function () {
      this.$getJSON(apis.partStockCheckDataPage, this.failForm).then((res) => {
        this.failList = res.data.list;
      });
    },
    // 切换页
    onCurrentPage1: function (page) {
      this.okForm.pageNum = page;
      this.getBatchOk();
    },
    // 切换每页数量
    onSizeChange1: function (size) {
      this.okForm.pageSize = size;
      this.getBatchOk();
    },
    // 切换页
    onCurrentPage2: function (page) {
      this.failForm.pageNum = page;
      this.getBatchFail();
    },
    // 切换每页数量
    onSizeChange2: function (size) {
      this.failForm.pageSize = size;
      this.getBatchFail();
    },
    // 保存入库
    saveBatchImport: function () {
      this.$postJSON(`${apis.partStockImport}/${this.okForm.flag}`).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success');
        this.closeDialog();
      });
    },
  },
};
</script>

<style lang="scss">
.part-inventory-batch-dialog {
  .btn-group {
    margin-bottom: 20px;
    overflow: hidden;

    .btn-add {
      height: 44px;
      line-height: 44px;
      text-align: center;
      background: rgba(245, 245, 245, 1);
      border: 1px dashed rgba(228, 228, 228, 1);
      color: #333333;
      font-size: 12px;
      position: relative;
      float: left;
      width: 980px;

      input {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        display: block;
        width: 100%;
        height: 100%;
        opacity: 0;
        cursor: pointer;
      }
      .icon {
        color: #00afff;
        font-size: 12px;
        margin-right: 4px;
      }
    }
    .btn-tpl {
      float: right;
      width: 162px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      border: 1px solid rgba(228, 228, 228, 1);
      margin-left: 10px;
      color: #333333;
      font-size: 12px;
      cursor: pointer;
      .icon {
        color: #00afff;
        font-size: 12px;
        margin-right: 4px;
      }
    }

    // .tip-tpl {
    //   color: #0d9ae0;
    //   cursor: pointer;
    // }
  }
  .tip-box {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    .result {
      // padding: 6px 10px 0;
      color: #262626;
      font-size: 12px;
      // height: 40px;
      flex: 1;
      align-self: center;
      .ok {
        color: blue;
      }
      .fail {
        color: red;
      }
    }
  }
}
</style>
